module.exports = __webpack_public_path__ + "static/img/contant_6.2f6a44b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_2/contant_6.jpg
// module id = Lyp4
// module chunks = 0